import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { mediaMax, spacing } from 'presentations/views/styles';
import { Trail } from 'presentations/views/components/atoms/Transition';
import { transformImageUrl } from 'presentations/assets';
import { EventTypeUserListItem } from 'presentations/api/schema/event_type_user';
import Avatar from 'presentations/views/components/atoms/Avatar';

interface Props {
  description: string | null;
  avatarImage?: string | null;
  avatarName?: string | null;
  host?: EventTypeUserListItem;
  isAnimate?: boolean;
  isDisableAnimation?: boolean;
}

export default function Component(props: Props) {
  return (
    <Container>
      {props.avatarImage && (
        <HostAvatar
          src={transformImageUrl(props.avatarImage, {
            width: 60,
            height: 60,
            fill: 'crop',
          })}
          alt={props.avatarName || ''}
        />
      )}
      {props.description && (
        <HostInsertText>
          {props.isDisableAnimation ? (
            props.description
          ) : (
            <Trail isOpen={!!props.isAnimate} direction="right">
              {props.description}
            </Trail>
          )}
        </HostInsertText>
      )}
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  align-items: center;
  ${mediaMax.tablet} {
    justify-content: flex-start;
  }
`;
const HostInsertText = styled.span`
  white-space: pre-wrap;
`;
const HostAvatar = styled(Avatar)`
  width: 60px;
  height: 60px;
  margin-right: ${spacing(16)};
  ${mediaMax.tablet} {
    width: 30px;
    height: 30px;
    margin-right: ${spacing(8)};
  }
`;
